module.exports = __webpack_public_path__ + "static/img/nothing3.3e5c682.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nothing3.png
// module id = 0MGT
// module chunks = 1